import PredictionChart from './prediction-chart';

export default PredictionChart;
